import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DateFieldComponent } from "src/app/pages/register-user/shared/components";
import { FormStepperService } from '../../services';

@Component({
  selector: 'app-form-step-1',
  standalone: true,
  imports: [
    DateFieldComponent
],
  templateUrl: './form-step-1.component.html',
  styleUrls: ['./form-step-1.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormStep1Component {
  public form = input<FormGroup>();
  
  private _formStepperService = inject(FormStepperService);
  
  protected isNextButtonClicked = this._formStepperService.isNextButtonClicked;
}
